import {override} from 'mobx';
import {ScoreboardWidgetScoreCellViewModel} from "../scoreboard-widget.score-cell-view-model";

export class ScoreboardWidgetTennisScoreCellViewModel extends ScoreboardWidgetScoreCellViewModel {
  @override get score(): String {
    const hasScore: Boolean = this._score > -1 || typeof this._score === "string";
    const score: String = hasScore ? this._score : '-';

    return score;
  }
}
